import dayjs from "@lib/dayjs"
import { getStatusColors, getStatusTextColors } from "@pages/JobPage/components/ViewByJob";
import { JobStatus } from "@utils/constants"
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";


const JobCard = ({ data }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isClosed = data?.status === JobStatus.CLOSED && "Closed";
  const isExpired = data?.status === JobStatus.EXPIRED && "Expired";

  return (
    <NavLink
      to={`/job/${data?.hiringCompany?._id}/${data?._id}/applicant-list`}
      state={data}
      onClick={() => {
        //   dispatch(setJobDetail(data));
        // navigate(`/job/${data?._id}/applicants`, { state: data });
      }}
      className="grid grid-cols-[1.3fr_1.3fr_0.3fr] gap-12 justify-between bg-white border-b border-[#ececec] rounded px-3 py-5 hover:bg-gray-50 cursor-pointer"
    >
      <div className="flex flex-col gap-1">
        <div className="flex items-center justify-between">
          <span className="text-[10px] text-light-black font-medium pl-2">
            {data?.refNo}
          </span>
          <div className={`text-xs font-medium ${getStatusTextColors({ status: data?.status })}`}>
            {data?.status === JobStatus.LIVE && "Live"}
            {data?.status === JobStatus.DRAFT && "Draft"}
            {data?.status === JobStatus.UNPUBLISHED && "Unpublished"}
            {data?.status === JobStatus.CLOSED && "Closed"}
            {data?.status === JobStatus.EXPIRED && "Expired"}
          </div>
        </div>
        <div className={`flex flex-col gap-1 rounded-md py-3 px-5 border border-y-gray-100 border-r-gray-100 ${getStatusColors({ status: data?.status })} border-l-[3px]`}>
          <span className="text-xs font-bold text-primary line-clamp-1">{data?.title}</span>
          <span className="text-xss font-medium text-light-black">Hiring Company:&nbsp;&nbsp;&nbsp;<span className="font-medium text-primary">{data?.hiringCompany?.companyName || 'N/A'}</span></span>
        </div>
        <div className="flex items-center justify-between pl-2">
          <div className="flex items-center gap-2">
            <span className="text-[10px] text-gray-400 font-medium">
              Published:
            </span>
            <span className="text-[10px] text-primary italic font-medium">
              {data?.publishedDate &&
                dayjs(data?.publishedDate).format("hh:mm a Do MMM YY")}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-[10px] text-gray-400 font-medium">
              {isClosed ? "Closed" : "Expiring"}:
            </span>
            <span className="text-[10px] text-primary italic font-medium">
              {dayjs(isClosed ? data?.updatedAt : data?.expiredAt).format(
                "hh:mm a Do MMM YY"
              )}
            </span>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-5 h-[1rem]">
          {
            data?.latestTrackerDetails?.createdAt ?
              <>
                <span className="text-xss text-light-black font-medium italic">
                  {dayjs(data?.latestTrackerDetails?.createdAt).format("hh:mm a")}
                </span>
                <span className="text-xss text-light-black font-medium italic">
                  {dayjs(data?.latestTrackerDetails?.createdAt).format("Do MMM YYYY")}
                </span>
              </>
              :
              null
          }
        </div>

        <div className="flex items-center bg-light-white-700 border border-gray-200 rounded-md h-[3.8rem] py-3 px-3">
          <span className="text-xs font-medium text-primary">
            Latest Activity : {data?.latestTrackerDetails?.status || 'N/A'}
          </span>
        </div>
      </div>

      <div className="flex flex-col items-center text-xss gap-2">
        <span className="">Applicants</span>
        <div className="relative w-[53px] h-[53px] flex items-center justify-center">
          {/* Glow layer */}
          {/* {data?.unViewedApplicants ? (
            <span className="absolute inset-0 rounded-full bg-green-500 opacity-5 animate-pulse"></span>
          ) : null} */}

          {/* Badge */}
          <div
            className={`relative z-10 w-[53px] h-[53px] rounded-full border-[3.5px] ${data?.applicantCount ? "border-green-500" : "border-gray-400"
              } flex items-center justify-center`}
          >
            <span className="text-xs font-semibold text-black">
              {data?.applicantCount}
            </span>
          </div>
        </div>
      </div>
    </NavLink>
  );
};


export default JobCard